import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, TRANSITIONS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'
import { getContrastingTextColor } from '../../../utils/colorUtils'

/**
 * Shared styled components for LabelChip
 * Used consistently across nodes, sidebars, and filters
 */

export const ChipContainer = styled.div<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs};
  background-color: ${(props) => props.$color};
  color: ${(props) => getContrastingTextColor(props.$color)};
  padding: 3px ${SPACING.sm};
  border-radius: ${BORDER_RADIUS.sm};
  font-size: ${TYPOGRAPHY.caption.fontSize} !important;
  font-weight: ${FONT_WEIGHT.bold} !important;
  max-width: 150px;
  position: relative;

  &:hover .remove-button {
    opacity: 1;
  }
`

export const ChipText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RemoveButton = styled.button<{ $bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    getContrastingTextColor(props.$bgColor) === 'white'
      ? 'rgba(0, 0, 0, 0.2)'
      : 'rgba(255, 255, 255, 0.3)'};
  border: none;
  border-radius: ${BORDER_RADIUS.sm};
  width: 14px;
  height: 14px;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  transition:
    ${TRANSITIONS.fast},
    background-color ${TRANSITIONS.fast};
  color: ${(props) => getContrastingTextColor(props.$bgColor)};

  &:hover {
    background: ${(props) =>
      getContrastingTextColor(props.$bgColor) === 'white'
        ? 'rgba(0, 0, 0, 0.4)'
        : 'rgba(255, 255, 255, 0.5)'};
  }

  &:active {
    transform: scale(0.9);
  }
`

// Variant with always-visible remove button (for filter sections)
export const RemoveButtonVisible = styled(RemoveButton)`
  opacity: 1;
`
